<template>
  <div class="w-full flex flex-col gap-1">


    <div class="flex gap-2">
      <button @click="clearList" class="flex-grow px-4 py-1 bg-trader-dark-gray text-black rounded hover:bg-trader-blue hover:text-trader-highlight">
        <i class="fa-solid fa-broom"></i>
      </button>
      <button @click="copyToClipboard" class="flex-grow px-4 py-1 bg-trader-dark-gray text-black rounded hover:bg-trader-blue hover:text-trader-highlight">
        <i class="fa-regular fa-clipboard"></i>
      </button>
    </div>
    <div class="w-full">
      <div
          class="min-h-[100px] w-full border border-trader-input-border p-2 shadow-inner-2 trader-input-background"
          :class="{
              'shadow-trader-red': productData?.customFields[formField.field]?.highlight,
              'bg-inactive': readOnly
            }"
      >
        <div v-for="(item, index) in bulletPoints"
             :key="'bullet-' + index"
             class="flex items-start gap-1 mb-1 bullet-point-row odd:bg-trader-dark-gray dark:odd:bg-trader-gray items-center">
          <span v-if="item !== ''" class="bullet-point ml-1">•</span>
          <!-- <div v-if="item == ''" class="absolute top-0 left-0 italic px-2 z-0">Kein Text</div> -->
          <div
              :contenteditable="!readOnly"
              :ref="`content-${index}`"
              @keydown="(e) => handleKeydown(e, index)"
              @paste="(e) => handlePaste(e, index)"
              @input="(e) => handleInput(e, index)"
              class="w-full outline-none min-h-[1.5em] break-words"
              style="white-space: pre-wrap;"


              v-text="item"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletPointList',
  props: {
    name: "Aufzählung",
    formField: {
      type: Object,
      default: () => ({})
    },
    productData: {
      type: Object,
      default: () => ({})
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {
      }
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    onFormEvent: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      bulletPoints: [''],
      isUpdating: false
    }
  },
  methods: {
    async updateFieldValue() {

      try {
        const value = this.bulletPoints
            .filter(point => point.trim() !== '')
            .join('\n');

        await this.onChangeProductFieldValue(this.formField.field, 'string', value);
      } catch (error) {
        console.error('Error updating field value:', error);
      }
    },
    focusContent(index) {
      this.$nextTick(() => {
        const element = this.$refs[`content-${index}`];
        if (Array.isArray(element) && element[0]) {
          element[0].focus();
          // Setze Cursor ans Ende des Contents
          const range = document.createRange();
          const sel = window.getSelection();
          range.selectNodeContents(element[0]);
          range.collapse(false);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
    },
    handleKeydown(event, index) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.isUpdating = true;
        this.bulletPoints.splice(index + 1, 0, '');
        this.$nextTick(() => {
          this.focusContent(index + 1);
          this.isUpdating = false;
        });
      } else if (event.key === 'Backspace' &&
          this.bulletPoints[index].trim() === '' &&
          this.bulletPoints.length > 1) {
        event.preventDefault();
        this.isUpdating = true;
        this.bulletPoints.splice(index, 1);
        this.$nextTick(() => {
          this.focusContent(Math.max(0, index - 1));
          this.isUpdating = false;
        });
      }
    },
    handleInput(event, index) {
      // Store the current selection/cursor position
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      const startOffset = range.startOffset;
      const element = event.target; // Store the target element

      // Update bulletPoints array with the new content
      const newText = element.innerText; //.replace(/\\n/g, ''); // Avoid replacing newline here, handle Enter explicitly

      // Only update if text actually changed to avoid unnecessary updates/cursor resets
      if (this.bulletPoints[index] !== newText) {
        this.bulletPoints[index] = newText;
        this.updateFieldValue();

        // Restore cursor position after Vue updates the DOM
        this.$nextTick(() => {
          // Check if the element still exists and is focused
          if (document.contains(element) && document.activeElement === element) {
            try {
                const newRange = document.createRange();
                // Ensure the offset is valid for the potentially changed text node
                const textNode = element.firstChild; // Assume single text node
                if (textNode && startOffset <= textNode.length) {
                    newRange.setStart(textNode, startOffset);
                    newRange.collapse(true); // Set cursor position
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                } else if (element.childNodes.length === 0 && startOffset === 0) {
                    // Handle empty element case
                    newRange.setStart(element, 0);
                    newRange.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                }
                // Optionally add a fallback to place cursor at the end if restoration fails
                // else {
                //   console.warn("Could not restore cursor position accurately.");
                //   newRange.selectNodeContents(element);
                //   newRange.collapse(false); // Place at end as fallback
                //   selection.removeAllRanges();
                //   selection.addRange(newRange);
                // }
            } catch (e) {
                console.error("Error restoring cursor position:", e);
                 // Fallback if error occurs during range setting
                 try {
                    const fallbackRange = document.createRange();
                    fallbackRange.selectNodeContents(element);
                    fallbackRange.collapse(false); // Place at end
                    selection.removeAllRanges();
                    selection.addRange(fallbackRange);
                 } catch (fallbackError) {
                    console.error("Error setting fallback cursor position:", fallbackError);
                 }
            }
          }
        });
      }
    },
    handlePaste(event, index) {
      const pastedText = event.clipboardData.getData('text');

      if (!pastedText.includes('\n')) {
        return true;
      }


      if (this.bulletPoints[index] != '') {
        index++;
      }

      event.preventDefault();

      const lines = pastedText.split(/\r?\n/).filter(line => line.trim() !== '');

      if (lines.length > 0) {
        this.isUpdating = true;
        this.$nextTick(() => {
          this.bulletPoints.splice(index, 0, ...lines);

          this.updateFieldValue();
          this.isUpdating = false;
        });
      }

    },
    initializeFromValue() {
      //const value = this.productData?.customFields[this.formField.field]?.value;


      const test = this.productData?.customFields[this.formField.field]?.highlight;


      const value = this.getFieldValue(this.formField.field) || '';

      if (value) {
        const points = value.split('\n').filter(point => point !== '');
        this.bulletPoints = points.length > 0 ? points : [''];
      }
    },
    clearList() {
      this.bulletPoints = [''];
      this.updateFieldValue();
    },
    async copyToClipboard() {
      const textToCopy = this.bulletPoints.filter(point => point.trim() !== '').join('\n');
      try {
        await navigator.clipboard.writeText(textToCopy);
      } catch (err) {
        console.error('Clipboard error:', err);
      }
    }
  },
  mounted() {
    this.initializeFromValue();
    this.onFormEvent('reset', this.initializeFromValue);
  },
  watch: {
    'productData': {
      immediate: true,
      handler: function () {
        this.initializeFromValue();
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.bullet-point {
  @apply text-lg leading-none select-none;
}

.bullet-point-row [contenteditable] {
  @apply px-1 py-0.5;
}

.bullet-point-row [contenteditable]:focus {
  @apply outline-none ring-1 ring-trader-blue bg-white;
}

/* Verhindert, dass der contenteditable div zusammenklappt, wenn er leer ist */
.bullet-point-row [contenteditable]:empty::before {
  content: '\00a0';
}
</style>